export default {
  path: '/meetings',
  name: 'r_meetings',
  meta: {
    middlewares: {
      auth: null,
      permission: 'MEETINGS',
    },
  },
  component: () => import('../../components/meetings/Meetings'),
  children: [
    {
      path: 'attendees',
      name: 'r_meetings-attendees',
      meta: {
        middlewares: {
          auth: null,
          permission: 'MEETINGS',
        },
      },
      props: {
        backLinkName: 'r_meetings',
      },
      component: () => import('../../components/meetings/Attendees'),
    },
    {
      path: 'date-time',
      name: 'r_meetings-date-time',
      meta: {
        middlewares: {
          auth: null,
          permission: 'MEETINGS',
        },
      },
      props: {
        backLinkName: 'r_meetings',
      },
      component: () => import('../../components/meetings/DateTime'),
    },
  ],
};
